<form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="row justify-content-center mt-5">
  <div class="col-12 col-md-6 col-lg-4">
    <app-input [form]="registerForm" formGroupName="firstName" placeHolder="First Name"></app-input>
  </div>
  <div class="d-100"></div>
  <div class="col-12 col-md-6 col-lg-4">
    <app-input [form]="registerForm" formGroupName="lastName" placeHolder="Last Name"></app-input>
  </div>
  <div class="d-100"></div>
  <div class="col-12 col-md-6 col-lg-4">
    <app-input [form]="registerForm" formGroupName="email" placeHolder="E-mail"></app-input>
  </div>
  <div class="d-100"></div>
  <div class="col-12 col-md-6 col-lg-4">
    <app-input [form]="registerForm" formGroupName="password" placeHolder="Password" inputType="password" [passwordHelpEnabled]="true"></app-input>
  </div>
  <div class="d-100"></div>
  <div class="col-12 col-md-6 col-lg-4">
    <app-input [form]="registerForm" formGroupName="confirmPassword" placeHolder="Confirm Password" inputType="password"></app-input>
  </div>
  <div class="d-100"></div>
  <div class="col-12 col-md-6 col-lg-4 mt-2">
    <button class="btn btn-primary w-100" type="submit">
      submit
    </button>
  </div>
</form>
